import * as React from 'react';
import { Attributes } from '../types';
import Box, { BoxProps } from '../Box/Box';
import './Logo.css';

export interface LogoProps extends BoxProps {
  size: string;
}

const Logo: React.ForwardRefRenderFunction<SVGSVGElement, Attributes<SVGSVGElement, LogoProps>> = (props, ref) => {
  const { size, ...rest } = props;

  return (
    <Box { ...rest }
        className="Logo"
        height={ size }
        ref={ ref }
        tag="svg"
        viewBox="0 0 100 100"
        width={ size }>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path d="M86,73.964 L86,78.43 L48.256,100 L44.349,97.767 L86,73.964 Z M86,64.56 L86,69.262 L40.234,95.416 L36.121,93.065 L86,64.56 Z M65.438,0.001 L69.543,2.347 L69.5426507,64.56 L73.6576507,62.209 L73.657,4.698 L77.772,7.049 L77.7716507,59.857 L81.8856507,57.506 L81.886,9.4 L86,11.751 L86,59.858 L32.007,90.714 L14,80.423 L14,75.729 L31.9996507,86.015 L36.1146507,83.663 L14,71.025 L14,66.323 L40.2286507,81.312 L44.3426507,78.961 L14,61.62 L14,56.543 L65.33443,27.207832 L65.32,27.183 L65.4286507,27.121 L65.4292464,0.001 L65.438,0.001 Z M65.4286507,50.632 L34.2146507,68.471 L48.4576507,76.61 L65.4286507,66.911 L65.4286507,50.632 Z M65.4286507,41.228 L25.9866507,63.768 L30.1006507,66.12 L65.4286507,45.931 L65.4286507,41.228 Z M65.4286507,31.824 L17.7576507,59.066 L21.8716507,61.417 L65.4286507,36.526 L65.4286507,31.824 Z" fill="currentColor"></path>
      </g>
    </Box>
  );
};

export default React.forwardRef(Logo);
